// Field `type` values as returned by GET /communicator/api/v1/endpoints/{eid}/tickets/config
export const FIELD_TYPES = {
  TEXT: 'text',
  TEXTAREA: 'textarea',
  PHONE: 'phone',
  EMAIL: 'email',
  FILE: 'file'
};
